import React, { useEffect, useRef } from 'react';
import { Formik, Field } from 'formik';
import { InputField } from '../../../../components/formFields/InputField';
import { SelectFormField } from '../../../../components/formFields/SelectFormField';
import { getFieldErrors } from '../../../../utils/apiError';

interface TeamsFormProps {
  formProps: Record<string, any>;
  submitOutside: boolean;
  submit: (values: any) => void;
  error?: any;
  reset?: boolean;
  resetConfirm?: () => void;
}

const TeamsForm = ({
  formProps,
  submitOutside,
  submit,
  error,
  reset = false,
  resetConfirm,
}: TeamsFormProps) => {
  const formRef = useRef<any>();

  useEffect(() => {
    if (reset === true) {
      formRef.current.setValues(formProps);
      resetConfirm();
    }
  }, [reset]);

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed && submitOutside) {
      formRef.current.submitForm();
    }

    return () => {
      isSubscribed = false;
    };
  }, [submitOutside]);

  useEffect(() => {
    formRef.current.setErrors(getFieldErrors(error));
  }, [error]);

  const init = ({ title, shortcut, leader, is_active }: any) => ({
    title,
    shortcut,
    leader,
    is_active: is_active === true ? 1 : 2,
  });

  const prepareData = (data: any[]) =>
    data.map((ele) => ({ title: ele.employee_full_name, id: ele.employee }));

  return (
    <div>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit({
            ...values,
            is_active: values.is_active === 1 ? true : false,
          });
        }}
      >
        {(props) => {
          const { values } = props;

          return (
            <div className="space-y-1">
              <Field
                name="shortcut"
                value={values.shortcut}
                label="Označení"
                placeholder="Označení"
                component={InputField}
                data-testid="teams-form-shortcut-input"
                required
              />
              <Field
                name="title"
                value={values.title}
                label="Název"
                placeholder="Název"
                component={InputField}
                data-testid="teams-form-title-input"
              />
              {formProps && Object.keys(formProps).length > 0 && (
                <>
                  <SelectFormField
                    name="leader"
                    data={prepareData(formProps?.members_list || [])}
                    label="Vedoucí"
                    placeholder="Vedoucí"
                    data-testid="teams-form-leader-select"
                  />
                  <SelectFormField
                    name="is_active"
                    data={[
                      { id: 1, title: 'Aktivní' },
                      { id: 2, title: 'Neaktivní' },
                    ]}
                    label="Stav"
                    placeholder=""
                    data-testid="teams-form-status-select"
                  />
                </>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default TeamsForm;
